module.exports = __webpack_public_path__ + "static/9-c8fe66d7735d28fa29b235c824c1fe38.jpg";